import {AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {ExgApplicationEventEmitter} from '../../misc/classes/ExgApplicationEventEmitter';
import {ExgApplicationTabService} from 'exc-tab-v2';
import {ExcRestService, IExcDataDistinct, IExcDataFilter, IExcDataPaging, IExcDataSort} from 'exc-rest-v2';
import {ExcSecurityService} from 'exc-security-v2';
import {ExgDataTableComponent, ExgModalService, ExgTableSettingsComponent} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ApplicationService} from '../../services/application.service';
import {BehaviorSubject} from 'rxjs';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';
import {IExcMetaInfo} from 'exc-rest-v2/lib/interfaces/IExcMetaInfo';
import {ExgFilterComponent} from '../../misc/exg-filter/exg-filter.component';
import {ExgFilterChipsComponent} from '../../misc/exg-filter-chips/exg-filter-chips.component';

@Component({
  selector: 'app-modal-select-case',
  templateUrl: './modal-select-case.component.html',
  styles: [
  ]
})
export class ModalSelectCaseComponent extends ExcTranslation implements OnInit, AfterViewInit {
  @Input() data: any;

  @ViewChild('VCcaseTable', { read: ExgDataTableComponent })
  VCcaseTable!: ExgDataTableComponent;
  @ViewChild('VCcaseTableFilterControl', { read: ExgFilterComponent })
  VCcaseTableFilterControl!: ExgFilterComponent;
  @ViewChild('VCcaseTableSearchControl', { read: ExgFilterComponent })
  VCcaseTableSearchControl!: ExgFilterComponent;
  @ViewChild('VCcaseTableSortControl', { read: ExgFilterComponent })
  VCcaseTableSortControl!: ExgFilterComponent;
  @ViewChild(ExgFilterChipsComponent) VCFilterChips!: ExgFilterChipsComponent;
  @ViewChild(ExgTableSettingsComponent) VCtableDefinitionSettings!: ExgTableSettingsComponent;
  /****************************/
  Events = new ExgApplicationEventEmitter();
  /****************************/
  caseTable = {
    selectKey: 'auID',
    multiSelection: false,
    prefilter: 0,
    state: 1,
    selectedRow: undefined as any,
    searchValue: '',
    selectedRows: [] as any[],
    selectedRowsClone: [] as any[],
    uiFilterEnumGroup: [
      {
        enmName: 'Schadenart',
        enmField: 'aue_enmIdent_SchadenArt',
        enmTable: 'AuftragE_EIS',
        enmAlt: true,
        enmAltTT: true,
      },
      {
        enmName: 'AuftragStatus',
        enmField: 'au_enmIdent_AuftragStatus',
        enmTable: 'Auftrag',
      },
      {
        enmName: 'AuftragTyp',
        enmField: 'au_enmIdent_AuftragTyp',
        enmTable: 'Auftrag',
      },
      // {enmName: 'AuftragTyp', enmField: 'au_enmIdent_AuftragTyp', enmTable: 'Auftrag'}
    ],
    uiFilterSearchFields: [
      { table: 'Auftrag', tableField: 'auNr' },
      {
        table: 'Auftrag',
        tableField: 'auAuftraggeberShort',
        repColumn: 'au_oeID_Auftraggeber',
      },
      { table: 'All', tableField: 'auLCU', groupCaption: 'Auftrag' },
      { table: 'All', tableField: 'auLCD', groupCaption: 'Auftrag' },
      { table: 'All', tableField: 'auCKD', groupCaption: 'Auftrag' },
      { table: 'AuftragE_EIS', tableField: 'aueLetzterQSPruefer', groupCaption: 'Auftrag' },
      {
        table: 'AuftragE_EIS',
        tableField: 'aueSchadenNr',
        groupCaption: 'Schaden',
      },
      {
        table: 'AuftragE_EIS',
        tableField: 'aueVersicherungsnehmer',
        groupCaption: 'Schaden',
      },
      {
        table: 'AuftragE_EIS',
        tableField: 'aueSchadenOrt',
        groupCaption: 'Schaden',
      },
    ],
    uiSortFieldGroup: [
      { fieldGroup: 'Auftrag', fieldTable: 'All', fieldName: 'auLCD' },
      { fieldGroup: 'Auftrag', fieldTable: 'All', fieldName: 'auCRD' },
      { fieldGroup: 'Auftrag', fieldTable: 'All', fieldName: 'auCKD' },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueSchadenDatum',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueAuftragsdatum',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueOrtsterminPlan',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueOrtstermin',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueOrtstermin2',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueSchadenmeldungVU',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueFristverlaengerungBis',
      },
      {
        fieldGroup: 'Auftrag',
        fieldTable: 'AuftragE_EIS',
        fieldName: 'aueZwischenberichtDatum',
      },
    ],
    uiFilter: [] as any[],
    uiSort: [] as any[],
    uiSortAktiv(): any[] {
      return this.uiSort.filter((sort: any) => sort.uiValue !== 0);
    },
    uiFilterAktiv(filterType?: number): any[] {
      return this.uiFilter
        .filter(
          (filters: any) =>
            !filterType || (filterType && filterType === filters.filterType)
        )
        .filter(
          (filters: any) =>
            (filters.uiValue === true && filters.filterType === 1) ||
            (filters.filterCondition.value.length > 0 &&
              filters.filterType === 2)
        );
    },
    data: [] as any[],
    tableDefinition: [] as any[],
    distinctData: [] as any[],
    MetaInfo: {
      dataPaging: {pageNo: 0, pageSize: 24} as IExcDataPaging,
      dataSort: {} as IExcDataSort,
      dataFilter: {} as IExcDataFilter,
      dataDistinct: {} as IExcDataFilter,
    } as IExcMetaInfo,
    paging: {
      pagingPage: 0,
      pagingEndRow: 0,
      pagingPageSize: 24,
      pagingTotalPages: 0,
      pagingTotalRows: 0,
      pagingStartRow: 0,
    },
    isLoading: true,
    toggleMultiSelection: (): void => {
      if (!this.caseTable.multiSelection) {
        this.caseTable.selectedRow = {};
        this.caseTable.selectedRows = [];
        this.caseTable.multiSelection = true;
      } else if (this.caseTable.multiSelection) {
        this.caseTable.selectedRow = {};
        this.caseTable.selectedRows = [];
        this.caseTable.multiSelection = false;
        this.caseTable.loadData();
      }
    },
    ready: () => {
      if (!this.caseTable.data || this.caseTable.data.length === 0) {
        this.caseTable.state = 2;
        if (this.VCcaseTable) {
          this.VCcaseTable.selectedRow = -1;
        }
      } else {
        this.caseTable.state = 0;
        if (this.VCcaseTable) {
          this.VCcaseTable.selectedRow = 0;
        }
      }
      this.init = false;
      this.caseTable.isLoading = false;
      this.tableIsLoading.next(this.caseTable.isLoading);

      if (this.VCFilterChips) {
        this.VCFilterChips.workspace.computeMetaInfo(
          this.appSvc.helperObj.clone(this.caseTable.MetaInfo)
        );
      }


    },
    selectionChanged: (index: number) => {
      // this.caseTable.selectedRow = this.caseTable.data[index];
      if (!this.caseTable.multiSelection) {
        const selection = this.caseTable.data[index];
        this.caseTable.selectedRows = [selection.auID];
      }
    },
    pageChanged: (page: number) => {
      if (this.caseTable.MetaInfo.dataPaging !== undefined) {
        this.caseTable.MetaInfo.dataPaging.pageNo = page;
      }
      this.caseTable.loadData();
    },
    search: (value: string) => {
      this.caseTable.searchValue = value;
      this.caseTable.pageChanged(1);
    },
    loadData: () => {
      const SELF = this;
      SELF.caseTable.state = 1;
      SELF.caseTable.isLoading = true;
      SELF.excRest
        .sget(
          SELF.excRest.computeUrl('CaseR_List', {
            filter: this.caseTable.prefilter,
            fts: this.caseTable?.searchValue,
          }),
          'caseListState',
          {
            MetaInfo: {
              dataPaging: this.caseTable.MetaInfo.dataPaging,
              dataSort: this.caseTable.MetaInfo.dataSort,
              dataFilter: this.caseTable.MetaInfo.dataFilter
            }
          }
        )
        .subscribe((response) => {
          if (response.success && response.data) {
            SELF.caseTable.data = response.data.Auftraege;
            SELF.caseTable.paging = response.paging.Auftraege;
          } else {
            SELF.caseTable.data = [];
            SELF.caseTable.paging = {
              pagingPage: 0,
              pagingEndRow: 0,
              pagingPageSize: 25,
              pagingTotalPages: 0,
              pagingTotalRows: 0,
              pagingStartRow: 0,
            };
          }
          SELF.caseTable.ready();
        });
    },
    getDistinctData: (dataDistinct: IExcDataDistinct) => {
      this.caseTable.MetaInfo.dataDistinct = dataDistinct;
      this.excRest
        .sget(
          this.excRest.computeUrl('CaseR_List', {
            filter: this.caseTable.prefilter,
            fts: this.caseTable?.searchValue,
          }),
          ExcCoreModule.Guid.NewGuid(),
          {MetaInfo: this.caseTable.MetaInfo}
        ).subscribe((ret: any) => {
        this.caseTable.distinctData = ret.data;
      });
    }
  };

  tableIsLoading = new BehaviorSubject(this.caseTable.isLoading);
  init = true;
  preFilterDefinition: any[] = [];
  selectedMod: any;
  selectedType: any;

  constructor(
    private chDecRef: ChangeDetectorRef,
    private exgApplicationTabService: ExgApplicationTabService,
    public excRest: ExcRestService,
    public excSecurity: ExcSecurityService,
    private modalSvc: ExgModalService,
    public enumSvc: EnumerationService,
    public appSvc: ApplicationService,
    ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
    this.initTableDefinition();

    if (this.data && this.data.length > 0) {
      this.caseTable.multiSelection = true;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (!this.selectedMod) {
        this.selectedMod = this.preFilterDefinition[3];
      }
      this.selectedType = this.selectedMod.types.find((i: any) => {
        return i.value === String(this.caseTable.prefilter);
      });

      if (this.data && this.data.length > 0) {
        for (const preSelection of this.data) {
          this.caseTable.selectedRows.push(preSelection.auID);
        }
        this.caseTable.selectedRowsClone = JSON.parse(JSON.stringify(this.caseTable.selectedRows));
      }

      this.VCcaseTableFilterControl.ApplyFilter();
      this.chDecRef.detectChanges();
    });
  }

  initialize(): void {
    const SELF = this;
    SELF.caseTable.loadData();
    SELF.initEnumerations();
    SELF.preFilterDefinition = [
      {
        value: 'active',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '1',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '2',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '3',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '4',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '7',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '9',
            get caption(): string {
              return SELF.enumSvc.getEnumerationText('AuftragStatus', Number(this.value));
            },
          },
          {
            value: '0',
            get caption(): string {
              return SELF.getRessource('active.' + this.value);
            },
          },
        ],
      },
      {
        value: 'closed',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '51',
            get caption(): string {
              return SELF.getRessource('closed.' + this.value);
            },
          },
          {
            value: '52',
            get caption(): string {
              return SELF.getRessource('closed.' + this.value);
            },
          },
          {
            value: '53',
            get caption(): string {
              return SELF.getRessource('closed.' + this.value);
            },
          }
        ],
      },
      {
        value: 'cancelled',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '61',
            get caption(): string {
              return SELF.getRessource('cancelled.' + this.value);
            },
          },
          {
            value: '62',
            get caption(): string {
              return SELF.getRessource('cancelled.' + this.value);
            },
          },
          {
            value: '63',
            get caption(): string {
              return SELF.getRessource('cancelled.' + this.value);
            },
          }
        ],
      },
      {
        value: 'all',
        get caption(): string {
          return SELF.getRessource(this.value + '.caption');
        },
        types: [
          {
            value: '-1',
            get caption(): string {
              return SELF.getRessource('all.' + this.value);
            },
          },
        ],
      },
    ];
    for (let i = new Date().getFullYear(); i >= new Date().getFullYear() - 3; i--)
    {
      SELF.preFilterDefinition[1].types.push(
        {
          value: '-5' + i,
          get caption(): string {
            return i as unknown as string;
          },
        }
      );
      SELF.preFilterDefinition[2].types.push(
        {
          value: '-6' + i,
          get caption(): string {
            return i as unknown as string;
          },
        }
      );
    }
    SELF.preFilterDefinition[1].types.push(
      {
        value: '5',
        get caption(): string {
          return SELF.getRessource('closed.' + this.value);
        },
      }
    );
    SELF.preFilterDefinition[2].types.push(
      {
        value: '6',
        get caption(): string {
          return SELF.getRessource('cancelled.' + this.value);
        },
      }
    );

    this.selectedMod = SELF.preFilterDefinition[0];
    this.caseTable.prefilter = 0;

  }

  initEnumerations(): void {
    this.caseTable.uiFilter = this.appSvc.metaInfo.dataFilter(
      this.caseTable.uiFilterEnumGroup,
      this.caseTable.uiFilterSearchFields
    );
    this.caseTable.uiSort = this.appSvc.metaInfo.dataSort(
      this.caseTable.uiSortFieldGroup
    );
  }

  initTableDefinition(): void {
    this.caseTable.tableDefinition = [
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'auNr')
        , value: 'auNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenNr')
        , value: 'aueSchadenNr'
        , fixed: true, align: 0, sort: 0, ordinal: 0, visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'aueVersicherungsnehmer')
        , value: 'aueVersicherungsnehmer'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueSchadenOrt')
        , value: 'aueSchadenOrt'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'au_oeID_Auftraggeber')
        , value: 'Auftraggeber_Name'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'au_enmIdent_AuftragStatus')
        , value: 'au_enmIdent_AuftragStatus'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('AuftragStatus', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('Auftrag', 'au_enmIdent_AuftragTyp')
        , value: 'au_enmIdent_AuftragTyp'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('AuftragTyp', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_SchadenArt')
        , value: 'aue_enmIdent_SchadenArt'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('Schadenart', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aue_enmIdent_Versicherungsart')
        , value: 'aue_enmIdent_Versicherungsart'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return this.enumSvc.getEnumerationText('Versicherungsart', value);
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueLetzterSachverstaendiger')
        , value: 'aueLetzterSachverstaendiger'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueLetzterQSPruefer')
        , value: 'aueLetzterQSPruefer'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueOrtstermin')
        , value: 'aueOrtstermin'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueOrtstermin2')
        , value: 'aueOrtstermin2'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueOrtstermin2')
        , value: 'aueOrtsterminPlan'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date'
        , dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CKU')
        , value: 'auCKU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%CKD')
        , value: 'auCKD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCU')
        , value: 'auLCU'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('All', '%LCD')
        , value: 'auLCD'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateTimeFormatShort')
        , visible: true
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueAbrechnungshinweis_enmIdent')
        , value: 'aueAbrechnungshinweis_enmIdent'
        , fixed: false
        , align: 0, sort: 0
        , visible: true
        , transformValue: (value: any) => {
          return value ? this.enumSvc.getEnumerationText('Abrechnungshinweis', value) : '';
        }
      },
      {
        caption: this.enumSvc.getFieldCaption('AuftragE_EIS', 'aueAbschlussdatum')
        , value: 'aueAbschlussdatum'
        , fixed: false
        , align: 0, sort: 0
        , type: 'date', dateFormat: this.getGlobal('DateFormat')
        , visible: true
      },
    ];
  }

  changePreFilterMod(event: any): void {
    this.selectedMod = event;
    // this.messageTable.prefilterMod = event.value;
    this.changePreFilterType(this.selectedMod.types[0]);
  }

  changePreFilterType(event: any): void {
    this.selectedType = event;
    this.caseTable.prefilter = event.value;
    this.VCcaseTableFilterControl.ApplyFilter();
  }

  openTableSettings($event: any): void {
    this.VCtableDefinitionSettings.openFilterConfig($event);
  }

  action(): void {
    if (!this.dirty()) {
      this.modalSvc.action(this.caseTable.selectedRows);
    }
  }

  close(): void {
    this.modalSvc.close();
  }

  dirty(): boolean {
    return (
      this.caseTable.selectedRows.length === 0
      || (
        JSON.stringify(this.caseTable.selectedRowsClone) === JSON.stringify(this.caseTable.selectedRows)
      )
    );
  }
}
